import { render, staticRenderFns } from "./BusinessText.vue?vue&type=template&id=49185814&"
import script from "./BusinessText.vue?vue&type=script&lang=js&"
export * from "./BusinessText.vue?vue&type=script&lang=js&"
import style0 from "./BusinessText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports